'use client';
import styled from 'styled-components';
import { colors, breakPoints } from '@/styles';
import { Mulish } from '@/styles/fonts';
import { ghostCardsCss } from './styled-ghost-cards';

export const StyledHtmlContent = styled.div`
  --content-spacing-multiplier: 1;
  --ghost-accent-color: #000000;
  --color-secondary-text: #999;

  font-size: 17px;
  line-height: 1.6;
  font-weight: 350;

  blockquote,
  body,
  dd,
  dl,
  figure,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p {
    margin-left: 0;
    margin-right: 0;

    font-family: ${Mulish.style.fontFamily} !important;
  }

  h1 {
    font-size: 2.4em;
    margin-top: 50px;
    @media (max-width: ${breakPoints.mobile}) {
      font-size: 2em;
    }
  }

  h2,
  h3 {
    display: flex;
    justify-content: left;
    font-size: 1.6em;
    color: #333;
    margin-top: 50px;
    font-weight: 800;
    @media (max-width: ${breakPoints.mobile}) {
      font-size: 1.4em;
      margin-top: 30px;
    }
    &:first-child {
      margin-top: 0;
    }
  }

  p {
    display: block;
    margin-block-start: 1em;
    margin-block-end: 1.5em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    unicode-bidi: isolate;

    a {
      color: ${colors.primary.black};
      text-decoration: underline;
      &:hover {
        text-decoration: underline;
      }
      overflow-wrap: break-word;
    }
  }

  a {
    color: #0077cc;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }

  figcaption {
    font-size: 16px;
    font-weight: 400;
    padding: 10px 0;
    text-align: left;
  }

  img {
    max-width: 100%;
    height: auto;
  }

  iframe {
    width: 100%;
    height: 100%;
    aspect-ratio: 16 / 9;
  }

  li {
    padding: 5px 0;
  }

  pre {
    border-radius: 5px;
    overflow-x: auto;
    font-size: 15px;

    &:has(> [class*='language-text']) {
      padding: 1em;
      background-color: #f5f5f5;
      border: 1px solid #ddd;
    }
  }

  & :not(.kg-card):not(table):not([id]) + :is(.kg-card, table) {
    margin-top: calc(2em * var(--content-spacing-multiplier, 1));
  }

  & :is(.kg-card, table) + :not(.kg-card):not(table):not([id]) {
    margin-top: calc(2em * var(--content-spacing-multiplier, 1));
  }

  & > * + * {
    margin-bottom: 0;
    margin-top: calc(1.6em * var(--content-spacing-multiplier, 1));
  }

  ${ghostCardsCss}

  figcaption {
    color: var(--color-secondary-text);
    text-align: center;
  }
`;
